import {categoryStore} from "../Stores/CategoryStore";

export const getUniqueLeafFilters = (category) => {
    const getLeafIds = (node) => {
        if (!node.children || node.children.length === 0) {
            return [node.id];
        }
        return node.children.flatMap(getLeafIds);
    };

    const leafIds = getLeafIds(category);
    const leafCategories = categoryStore.categoryList.filter(category => leafIds.includes(category.id));

    const filterKeys = {};
    leafCategories.forEach(leaf => {
        leaf.customFilters?.forEach(filter => {
            filterKeys[filter.key] = filter;
        })
    })

    return filterKeys;
}